<template>
  <div class="card card-custom card-stretch gutter-b setting-item">
    <!--begin::Header-->
    <div class="card-header align-items-center">
      <h3 class="card-title align-items-start">
        <span class="title font-weight-bold">
          {{ i18n.humidity }}
        </span>
        <span v-bind:style="isOperatingCorrectly" class="ml-5">{{ elementObj.currentValue }}% (now)</span>
      </h3>
      <div class="card-toolbar toolbar-symbol">
        <a href="#" class="btn btn-icon btn-hover-light-primary draggable-handle">
          <i class="ki ki-menu"></i>
        </a>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body">
      <!--begin::form-group-->
      <div v-if="this.controllerType !== '제닉스' " class="form-group row">
        <label class="col-form-label col-12 col-lg-6">
          <span class="font-weight-normal">{{ i18n.target }}</span>
        </label>
        <div class="col-12 col-lg-6">
          <b-form-spinbutton id="sb-01" v-model="humidityValue" min="0" max="100" size="sm" @change="conveyData('humidityValue')"></b-form-spinbutton>
        </div>
      </div>
      <!--end::form-group-->

      <div v-if="this.controllerType == '엠코피아'" class="form-group row">
        <label class="col-form-label col-12 col-lg-2 align-self-center" style="margin-right: auto;">
          <span class="font-weight-normal">{{ i18n.management }}</span>
        </label>
        <b-card no-body class="col-12 col-lg-9 d-flex flex-wrap flex-row pt-4 pb-4">
          <div class="col-6 pl-0 pr-2 mb-5" style="display: flex; flex-direction: column; align-items: center">
            <div>{{i18n.maxDay}}</div>
            <b-form-spinbutton v-model="humidityMax" min="0" max="100" size="sm" @change="conveyData('humidityMax')"></b-form-spinbutton>
          </div>
          <div class="col-6 pl-2 pr-0 mb-5" style="display: flex; flex-direction: column; align-items: center">
            <div>{{i18n.minNight}}</div>
            <b-form-spinbutton v-model="humidityMin" min="0" max="100" size="sm" @change="conveyData('humidityMin')"></b-form-spinbutton>
          </div>
          <div class="col-6 pl-0 pr-2" style="display: flex; flex-direction: column; align-items: center">
            <div>🌙 : {{humiditynMax}}%</div>
          </div>
          <div class="col-6 pl-2 pr-0" style="display: flex; flex-direction: column; align-items: center">
            <div>🌙 : {{humiditynMin}}%</div>
          </div>
        </b-card>
      </div>

      <div v-if="this.controllerType === '제닉스' " class="form-group row">
        <label class="col-form-label col-12 col-lg-2 align-self-center pb-2" style="margin-right: auto;">
          <span class="font-weight-normal">{{ i18n.targetDay }}</span>
        </label>  
        <b-card no-body class="col-12 col-lg-10 d-flex flex-wrap flex-row pt-2 pb-4 mb-2">
          <div class="col-6 pl-0 pr-2" style="display: flex; flex-direction: column; align-items: center">
            <div>{{i18n.target}}</div>
            <b-form-spinbutton v-model="humValues[0]" min="0" max="100" size="sm" @change="conveyData('humValues[0]')"></b-form-spinbutton>
          </div>
          <div class="col-6 pl-2 pr-0" style="display: flex; flex-direction: column; align-items: center">
            <div>{{i18n.diff}}</div>
            <b-form-spinbutton v-model="humDiffs[0]" min="0" max="50" size="sm" @change="conveyData('humDiffs[0]')"></b-form-spinbutton>
          </div>
        </b-card>
        <label class="col-form-label col-12 col-lg-2 align-self-center pb-2" style="margin-right: auto;">
          <span class="font-weight-normal">{{ i18n.targetNight }}</span>
        </label>  
        <b-card no-body class="col-12 col-lg-10 d-flex flex-wrap flex-row pt-2 pb-4 mb-2">
          <div class="col-6 pl-0 pr-2" style="display: flex; flex-direction: column; align-items: center">
            <div>{{i18n.target}}</div>
            <b-form-spinbutton v-model="humValues[1]" min="0" max="100" size="sm" @change="conveyData('humValues[1]')"></b-form-spinbutton>
          </div>
          <div class="col-6 pl-2 pr-0" style="display: flex; flex-direction: column; align-items: center">
            <div>{{i18n.diff}}</div>
            <b-form-spinbutton v-model="humDiffs[1]" min="0" max="50" size="sm" @change="conveyData('humDiffs[1]')"></b-form-spinbutton>
          </div>
        </b-card>
      </div>

      <div v-if="this.controllerType !== '제닉스' " class="form-group row">
        <label class="col-form-label col-12 col-lg-2 align-self-center" style="margin-right: auto;">
          <span class="font-weight-normal">{{ i18n.abnormalalert }}</span>
        </label>
        <b-card no-body class="col-12 col-lg-9 d-flex flex-wrap flex-row pt-4 pb-4">
          <div class="col-6 pl-0 pr-2 mb-5" style="display: flex; flex-direction: column; align-items: center">
            <div>{{i18n.maxDay}}</div>
            <b-form-spinbutton v-model="humidityLimithigh" min="0" max="100" size="sm" @change="conveyData('humidityLimithigh')"></b-form-spinbutton>
          </div>
          <div class="col-6 pl-2 pr-0 mb-5" style="display: flex; flex-direction: column; align-items: center">
            <div>{{i18n.minNight}}</div>
            <b-form-spinbutton v-model="humidityLimitlow" min="0" max="100" size="sm" @change="conveyData('humidityLimitlow')"></b-form-spinbutton>
          </div>
          <div class="col-6 pl-0 pr-2" style="display: flex; flex-direction: column; align-items: center">
            <div>🌙 : {{humiditynLimithigh}}%</div>
          </div>
          <div class="col-6 pl-2 pr-0" style="display: flex; flex-direction: column; align-items: center">
            <div>🌙 : {{humiditynLimitlow}}%</div>
          </div>
        </b-card>
      </div>
      <!--end::form-group-->
    </div>
    <!--end::Body-->
  </div>
</template>
<script>
import {syncObj3} from '@/core/services/funcs';
import i18n from '@/core/plugins/vue-i18n.js';

export default {
  name: "Setting2",
  props: {
    elementObj: Object,
    mutateValue: Function,
    effectValue: Number,
    controllerType: String
  },
  watch: {
    effectValue(){
      if(this.elementObj) syncObj3(this.elementObj, this);      
    }
  },
  data() {
    return {
      humidity: '',
      humidityValue: 0,      
      humValues: [],
      humDiffs: [],
      humidityLimithigh: 0,
      humidityLimitlow: 0,
      humidityMin: 0,
      humidityMax: 0,
      humiditynLimithigh: 0,
      humiditynLimitlow: 0,
      humiditynMin: 0,
      humiditynMax: 0,
      i18n: {
        management: i18n.t('cultivationEnvControlSetting.management'),
        abnormalalert: i18n.t('cultivationEnvControlSetting.abnormalalert'),
        diff: i18n.t('cultivationEnvControlSetting.diff'),
        humidity: i18n.t('cultivationEnvControlSetting.humidity'),
        target: i18n.t('cultivationEnvControlSetting.target'),
        targetDay: i18n.t('cultivationEnvControlSetting.targetDay'),
        targetNight: i18n.t('cultivationEnvControlSetting.targetNight'),
        min: i18n.t('cultivationEnvControlSetting.min'),
        max: i18n.t('cultivationEnvControlSetting.max'),
        limitHigh: i18n.t('cultivationEnvControlSetting.limitHigh'),
        maxDay: i18n.t('cultivationEnvControlSetting.maxDay'),
        minNight: i18n.t('cultivationEnvControlSetting.minNight')
      }
    };
  },
  computed: {
    isOperatingCorrectly() {
      if (this.elementObj.currentValue > this.humidityMax || this.elementObj.currentValue < this.humidityMin) {
        return {
          color: 'red'
        }
      }

      return {
        color: 'green'
      }
    },
  },
  methods: {
    conveyData(key){
      this.mutateValue('humidity', key, this[key]);
      var nkey = "";

      if (key == "humidityMax"){
        nkey =  "humiditynMax";
        this[nkey] = this[key]+10
      } else if (key == "humidityMin") {
        nkey =  "humiditynMin";
        this[nkey] = this[key]+10
      } else if (key == "humidityLimithigh"){
        nkey =  "humiditynLimithigh";
        this[nkey] = this[key]+10
      } else if (key == "humidityLimitlow"){
        nkey =  "humiditynLimitlow";
        this[nkey] = this[key]+10
      } else if (key == "humValues[0]"){
        nkey = "humValues"        
        this[nkey][0] = this.humValues[0]
      } else if (key == "humValues[1]"){
        nkey = "humValues"        
        this[nkey][1] = this.humValues[1]
      } else if (key == "humDiffs[0]"){
        nkey = "humDiffs"        
        this[nkey][0] = this.humDiffs[0]
      } else if (key == "humDiffs[1]"){
        nkey = "humDiffs"        
        this[nkey][1] = this.humDiffs[1]
      }
      
      this.mutateValue('humidity', nkey, this[nkey]);
    }
  }
};
</script>
